import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const TIBusinessConfig = initConst<IBusinessConfigs>(() => ({
  TIAnstalld: {
    defaultColumns: [
      { attributeDef: 'ANSTALLNINGSNR', caption: 'Nr' },
      { attributeDef: 'namn', caption: 'Namn/Benämning' },
      { attributeDef: 'attestomradeBenamning', caption: 'Attestområde' },
      { attributeDef: 'DagensArbtidfakt', caption: 'Arbetstidsfaktor' },
      { attributeDef: 'DagensSemfakt', caption: 'Semesterfaktor' },
      { attributeDef: 'ANSTALLD_FROM', caption: 'Från' },
      { attributeDef: 'ANSTALLD_TOM', caption: 'Till' },
      { attributeDef: 'DagensSchema', caption: 'Schema' },
    ],
  },
  TIProjekt: {
    defaultColumns: [
      { attributeDef: 'PROJEKTNR', caption: 'Projekt' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'prioritetBenamning', caption: 'Prioritet' },
    ],
  },
  TIArbetsuppgift: {
    defaultColumns: [
      { attributeDef: 'projektNrBenamning', caption: 'Projekt' },
      { attributeDef: 'nrRubrik', caption: 'Uppgift' },
      { attributeDef: 'ansvarigNamn', caption: 'Ansvarig' },
      { attributeDef: 'arbetstid', caption: 'Tid' },
      { attributeDef: 'kundNrNamn', caption: 'Kund' },
      { attributeDef: 'fakturerasAntal', caption: 'Faktureras' },
      { attributeDef: 'STANDIG', caption: 'Ständig' },
      { attributeDef: 'avslutadTid', caption: 'Avslutad, datum' },
    ],
  },
  TIDagAnstalld: {
    defaultColumns: [
      { attributeDef: 'anstalldNamn', caption: 'Anställd' },
      { attributeDef: 'Veckodag', caption: 'Dag' },
      { attributeDef: 'datum', caption: 'Datum' },
      { attributeDef: 'arbetstid', caption: 'Tid' },
      { attributeDef: 'rapporteratFran', caption: 'Fråntid' },
      { attributeDef: 'rapporteratTill', caption: 'Tilltid' },
    ],
  },
  TIManAnstalld: {
    defaultColumns: [
      { attributeDef: 'MANAD', caption: 'Månad' },
      { attributeDef: 'anstalld.ANSTALLNINGSNR', caption: 'Nr' },
      { attributeDef: 'anstalld.namn', caption: 'Namn' },
      { attributeDef: 'attFordela', caption: 'Att fördela' },
      { attributeDef: 'fordeladTid', caption: 'Fördelat' },
    ],
  },
  TITidrapportering: {
    defaultColumns: [
      { attributeDef: 'datum', caption: 'Datum' },
      { attributeDef: 'antalTid', caption: 'Tid/Antal' },
      { attributeDef: 'namn', caption: 'Namn' },
      { attributeDef: 'projektBenamning', caption: 'Projekt' },
      { attributeDef: 'benamning', caption: 'Arbetsuppgift' },
      { attributeDef: 'loneartKodBenamning', caption: 'Rapp kod' },
      { attributeDef: 'rappkod2KodBenamning', caption: '(Rapp kod 2)' },
      { attributeDef: 'rapporteringstextSql', caption: 'Beskrivning' },
      { attributeDef: 'KATEGORI', caption: 'Inrapporteringssätt' },
    ],
  },
  TILonefil: {
    defaultColumns: [
      { attributeDef: 'ID', caption: 'Nr' },
      { attributeDef: 'DATUM', caption: 'Skapad, datum' },
      { attributeDef: 'UTBETALNINGSMANAD', caption: 'Utbetalningsmånad' },
      { attributeDef: 'BACKAD_DATUM', caption: 'Backad, datum' },
      { attributeDef: 'RAPP_TILL', caption: 'Tidrapporteringar t o m datum' },
    ],
  },
  Tidrapport: {
    defaultColumns: [
      { attributeDef: 'Kategori', caption: 'Kategori' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'SKAPAD_DATUM', caption: 'Skapad' },
      { attributeDef: 'ANDRAD_DATUM', caption: 'Ändrad' },
      { attributeDef: 'Sidhuvud', caption: 'Sidhuvud' },
    ],
  },
  TITidGrupp: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
  TIInstallningar: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'MAX_FLEXTID', caption: 'Max flextidssaldo' },
      { attributeDef: 'MIN_FLEXTID', caption: 'Min flextidssaldo' },
      { attributeDef: 'TID_INSTAMPLING', caption: 'Extra tid vid instämpling' },
      { attributeDef: 'TID_UTSTAMPLING', caption: 'Extra tid vid utstämpling' },
      {
        attributeDef: 'MAN_STAMPEL_TID',
        caption: 'Avvikande tid vid stämpling',
      },
    ],
  },
  TIVeckoschema: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'Timmar2', caption: 'Timmar' },
    ],
  },
  TIDagSchema: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'calcArbetstid2', caption: 'Arbetstidsmått' },
    ],
  },
  TIOBTid: {
    defaultColumns: [
      { attributeDef: 'DATUM', caption: 'Datum' },
      { attributeDef: 'FRAN_TID', caption: 'Fråntid' },
      { attributeDef: 'TILL_TID', caption: 'Tilltid' },
      { attributeDef: 'OB_Benamning', caption: 'OB-Typ' },
    ],
  },
  TITidbank: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'totaltSaldo', caption: 'Summa tid' },
    ],
  },
  TILoneartKategori: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: '' },
      { attributeDef: 'BENAMNING', caption: '' },
    ],
  },
  TIRapporteringskod: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'enhet', caption: 'Enhet' },
      { attributeDef: 'KALKYLPRIS', caption: 'Kalkylpris' },
      { attributeDef: 'artikelNrBenamning', caption: 'Artikel' },
      { attributeDef: 'ANVANDNING', caption: 'Användning' },
      { attributeDef: 'kategoriBenamning', caption: 'Kategori' },
      { attributeDef: 'loneartNrBenamning', caption: 'Löneart' },
    ],
  },
  TIRapporteringskod2: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  TIAnstalldKategori: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  TIFaktureringstyp: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'STANDARD', caption: 'Standard' },
    ],
  },
  TIPrioritet: {
    defaultColumns: [
      { attributeDef: 'PRIORITET', caption: 'Prioritet' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'standardText', caption: ' ' },
    ],
  },
  TIAttestomrade: {
    defaultColumns: [
      { attributeDef: 'KOD', caption: 'Kod' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
    ],
  },
  TIAttestkategori: {
    defaultColumns: [{ attributeDef: 'BENAMNING', caption: 'Benämning' }],
  },
  TILoneart: {
    defaultColumns: [
      { attributeDef: 'AV_LONEART', caption: 'Typ' },
      { attributeDef: 'NR', caption: 'Nummer' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'SUMMERING', caption: 'Summering' },
      { attributeDef: 'EXPORTERA_ANTAL', caption: 'Exportera' },
    ],
  },
}));

export default TIBusinessConfig;
